import { Bell } from "lucide-react";
import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog";
import NotificationPreferencesPanel from "@/components/notifications/NotificationPreferencesPanel";

export default function NotificationSettings({ trigger }: { trigger?: React.ReactNode }) {
  return (
    <Dialog>
      <DialogTrigger asChild>
        {trigger || (
          <Button variant="ghost" size="sm">
            <Bell className="mr-2 h-4 w-4" />
            Notification Settings
          </Button>
        )}
      </DialogTrigger>
      <DialogContent className="max-h-[85vh] max-w-4xl overflow-y-auto">
        <DialogHeader>
          <DialogTitle>Notification Settings</DialogTitle>
          <DialogDescription>
            Choose how you want to be notified for different events.
          </DialogDescription>
        </DialogHeader>
        <NotificationPreferencesPanel showCard={false} />
      </DialogContent>
    </Dialog>
  );
}
